<template>
  <div class="film-mini">
    <a
      class="film-mini-title"
      @click.prevent="openMovie(movie.Id, cityId, date)"
    >
      {{ movieTitle }}
      <span class="film-label">{{ movieAge }}</span>
    </a>
    <div class="film-mini-genre">{{ movieGenres }}</div>
    <div class="schedule-item">
      <div class="schedule-preview">
        <div class="films-inline-tem">
          <a class="film-mini-img">
            <a @click.prevent="openMovie(movie.Id, cityId, date)">
              <div class="film-mini-poster-wrapper">
                <img :src="movieImage" class="film-mini-poster" />
              </div>
            </a>
          </a>
        </div>
      </div>
      <div class="schedule-theatres">
        <div
          v-for="theatre in theatres"
          :key="theatre.Id"
          class="schedule-theatre"
        >
          <div class="schedule-theatre-info">
            <div class="schedule-theatre-name">{{ theatre.Name }}</div>
            <div class="schedule-theatre-city">{{ theatre.Address }}</div>
          </div>
          <TimesByFormat
            v-for="(format, index) in Object.keys(theatre.TimesByFormat)"
            :theatre="theatre"
            :movieId="movie.Id"
            :format="format"
            :key="index"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimesByFormat from './TimesByFormat/TimesByFormat';
import urlQueryParts from '../../../helpers/urlQueryParts';

export default {
  name: 'Movie',
  props: ['movie', 'cityId', 'date'],
  components: { TimesByFormat },
  computed: {
    movieGenres() {
      return this.movie.Genre;
    },
    movieTitle() {
      return this.movie.Title;
    },
    movieImage() {
      return (
        this.movie.Image ||
        'https://cdn.pzpreprod.66bit.ru/thumbs/9d39246906748e4990243fb3fe9ec334d652e3d0.jpg'
      );
    },
    movieAge() {
      return this.movie.Age + '+';
    },
    theatres() {
      return this.movie.Theatres;
    },
  },
  methods: {
    openMovie(filmId, cityId, date) {
      console.log(filmId, cityId, date);
      this.$router.push(
        `/filmSchedule${urlQueryParts({ filmId, cityId, date: Number(date) })}`,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.film-mini {
  padding: 2rem;

  &:not(:last-child) {
    border-bottom: 1px solid #3d3d3d;
  }
}

.schedule-item {
  display: -ms-flexbox;
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  gap: 8px 42px;
}

.film-mini-title {
  font-family: 'sans-serif', 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 32px;
  display: flex;
  align-items: center;
  color: #ffffff;
  cursor: pointer;
  gap: 1rem;
  width: fit-content;
}

.film-mini-genre {
  color: rgba(255, 255, 255, 0.53);
  font-size: 16px;
  line-height: 20px;
  margin-top: 0.25rem;
}

.film-label {
  background-color: #f49d1a;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.film-mini-poster-wrapper {
  position: relative;
  text-align: center;
  padding-top: 0.5rem;
}

.film-mini-poster {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 0;
  display: flex;
  width: auto;
  height: auto;
  max-height: 286px;
  width: 200px;
}

.schedule-preview {
  display: flex;
}

.films-inline-tem {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
}

.film-mini-img {
  justify-content: flex-start;
  display: flex;
  cursor: pointer;
}

.schedule-theatres {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.schedule-theatre {
  display: flex;
  padding: 10px 0;
  width: 100%;
  flex-direction: column;
  gap: 10px;
}

.schedule-theatre-info {
  display: flex;
  flex-direction: column;
}

.schedule-theatre-name {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.schedule-theatre-city {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  color: #b3b3b3;
  margin-top: 0.5rem;
  font-size: 16px;
  line-height: 20px;
}
</style>
